export const SCREEN_SIZE_MOBILE = 1080;
export const SCREEN_SIZE_DESKTOP = 1920;
export const CSS_SIZES_VARIABLES_LIST = [1, 2, 4, 6, 8, 14, 16, 22, 26, 34, 42, 56, 68, 74, 90, 110, 122, 144, 164, 178, 234, 288, 360, 378, 466, 610, 754, 988, 1260];
export const SCI_SIDEBAR_SIZE = 534;
